import { all } from 'redux-saga/effects';
import { sagas as sharedSagas } from '@innovyze/stylovyze';
import {sagas as mapUiSagas } from '@innovyze/map-components';
import { assetSchemaRootSaga } from '@innovyze/lib_asset_schema_store'
import createSagaMiddleware from 'redux-saga';

export const sagaMiddleware = createSagaMiddleware();

export const initSagas = () => {
  sagaMiddleware.run(function* () {
    yield all([sharedSagas(), mapUiSagas(), assetSchemaRootSaga()]);
  });
};
